import { render, staticRenderFns } from "./Tutor_material.vue?vue&type=template&id=dbb49048&scoped=true"
import script from "./Tutor_material.vue?vue&type=script&lang=js"
export * from "./Tutor_material.vue?vue&type=script&lang=js"
import style0 from "./Tutor_material.vue?vue&type=style&index=0&id=dbb49048&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbb49048",
  null
  
)

export default component.exports